import React from 'react';

export type SearchPageContextProps = {
  inVariantSimplifiedMobileOwnerSearchFormExperiment?: boolean;
  isRollout1SimplifiedMobileOwnerSearchFormExperiment?: boolean;
};

export const SearchPageContext = React.createContext<SearchPageContextProps>({});
